//Language Switcher
import React from "react";
import { useTranslation } from "react-i18next";

function LangChange(){
    const {i18n} = useTranslation();
    const changeLang = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem("lang",lang);
    };
    return(
        <div>
            <button onClick={()=>changeLang("en")}>English</button>
            <button onClick={()=>changeLang("ar")}>عربي</button>
        </div>
    );
}
export default LangChange;